// extracted by mini-css-extract-plugin
export var chevronIcon = "_42-2";
export var teamName = "_42-1";
export var teamSwitcherButton = "_42-0";